import React from 'react';
import ReactDOM from 'react-dom/client';

import { App } from './App';
import { client } from './api/generated/client.gen';
import { initKeycloak } from './auth/keycloak';
import { getApiBaseUrl, getConfig, loadConfig } from './lib/config';
import './index.css';

async function bootstrap() {
  await loadConfig();
  const cfg = getConfig();

  initKeycloak(cfg.keycloakUrl, cfg.keycloakRealm, cfg.keycloakClientId);

  // The request interceptor in ./api/client sets baseURL per request (the real
  // guarantee). We still set the default here so synchronous URL builders that read
  // client.instance.defaults.baseURL (counters/gdpr CSV export links) resolve correctly.
  const baseURL = getApiBaseUrl();
  client.setConfig({ baseURL });
  client.instance.defaults.baseURL = baseURL;

  await import('./api/client');

  const rootEl = document.getElementById('root');
  if (!rootEl) throw new Error('Root element not found');

  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

bootstrap();
